var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-card',{attrs:{"type":"1"},scopedSlots:_vm._u([{key:"img",fn:function(){return [_c('img',{attrs:{"src":require("../assets/out.gif"),"alt":""}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }